import * as React from 'react';
import { ICalendarContext } from '../../types';

const CalendarContext = React.createContext<ICalendarContext | undefined>(
  undefined,
);
CalendarContext.displayName = 'CalendarContext';

const Calendar: React.FC<ICalendarContext> = ({
  selectionType,
  currentRange,
  focusedDate,
  selectedRange,
  children,
}) => {
  const memoContextValue = React.useMemo(
    () => ({
      focusedDate: focusedDate,
      selectionType: selectionType,
      currentRange: currentRange,
      selectedRange: selectedRange,
    }),
    [currentRange, focusedDate, selectedRange, selectionType],
  );

  return (
    <CalendarContext.Provider value={memoContextValue}>
      {children}
    </CalendarContext.Provider>
  );
};

export const useCalendar = (): ICalendarContext => {
  const context = React.useContext(CalendarContext);
  if (!context) {
    throw new Error(
      'This component must be used within a <Calendar> component',
    );
  }
  return context;
};

export { Calendar };
